import { render, staticRenderFns } from "./OnlineOrders.vue?vue&type=template&id=cd1103ea&lang=pug"
import script from "./OnlineOrders.vue?vue&type=script&lang=js"
export * from "./OnlineOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports